import { ProfileType, ResumeTabsType } from '../../../../../types/ResumeTypes';
import styled from 'styled-components';

import C from '../ViewerMode.module.scss';
import S from './BasicInfoViewer.module.scss';
import defaultProfile from '../../assets/default_profile.svg';
import { DateTimeUtils } from '../../../../../utils/DateTimeUtils';
import _ from 'lodash';

interface BasicInfoViewer {
  profile: ProfileType;
  resumeTabs: ResumeTabsType;
}

const BasicInfoViewer = (props: BasicInfoViewer) => {
  const { profile, resumeTabs } = props;

  if (profile === undefined) {
    return null;
  }

  return (
    <>
      <section ref={resumeTabs[0].element} className={`${C.viewer_section} wrapper`}>
        <h4 className={`${C.section_title} h4`}>인적사항</h4>
        <article className={`${C.common_box} ${S.basic_info_box} vertical-center`}>
          <div className={S.profile_img_wrap}>
            {/* 기본 이미지 */}
            <ProfileImg
              backgroundImage={profile.profileImageUrl?.mediaUrl || defaultProfile}
            ></ProfileImg>
            {/* 예시 이미지 */}
            {/* <ProfileImg backgroundImage={exampleImg}></ProfileImg> */}
          </div>
          <div className={`${C.profile_text_wrap} ${S.basic_text_wrap}`}>
            <div className={`${C.profile_text_line} ${S.top_line}`}>
              <div className={C.text_el_wrap}>
                <h2 className="h2">{profile.localName || ''}</h2>
                {profile.enName && <span className="divided-line" />}
                <h2 className="h2">{profile.enName || ''}</h2>
                <span className="divided-line" />
                <h3 className="h3">
                  {profile.birthday}(만 {DateTimeUtils.calculateAge(profile.birthday)}세)
                </h3>
                <span className="divided-line" />
                <h3 className="h3">
                  {_.isEmpty(profile.gender) ? '' : profile.gender === 'MEN' ? '남' : '여'}
                </h3>
              </div>
            </div>
            <div className={C.profile_text_line}>
              <div className={C.text_el_wrap}>
                <h4 className="h4">휴대전화</h4>
                <span className="divided-line" />
                <h4 className="b1">{profile.phoneNumber || ''}</h4>
              </div>
              <div className={C.text_el_wrap}>
                <h4 className="h4">E-mail</h4>
                <span className="divided-line" />
                <h4 className="b1">{profile.email || ''}</h4>
              </div>
            </div>
            <div className={C.profile_text_line}>
              <div className={C.text_el_wrap}>
                <h4 className="h4">국적</h4>
                <span className="divided-line" />
                <h4 className="h4">{profile.nation || ''}</h4>
              </div>
              <div className={C.text_el_wrap}>
                <h4 className="h4">주소</h4>
                <span className="divided-line" />
                <h4 className="h4">{profile.address + ' ' + profile.addressDetail || ''}</h4>
              </div>
            </div>
          </div>
        </article>
        <hr />
      </section>
    </>
  );
};

export default BasicInfoViewer;

const ProfileImg = styled.div<{ backgroundImage: string }>`
  width: 20rem;
  height: 20rem;
  border-radius: 50%;
  background-image: url(${(props) => props.backgroundImage});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
`;
